export const defaultState = () => {
    return {
        showInfo: false
    }
}

const state = defaultState()
export default state
